"use strict";

exports.__esModule = true;
exports.boxPropTypes = exports.spacingPropType = void 0;

var _propTypes = require("prop-types");

var spacingPropType = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]))]);
exports.spacingPropType = spacingPropType;
var boxPropTypes = {
  breakpoints: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])),
  height: spacingPropType,
  inline: (0, _propTypes.oneOfType)([_propTypes.bool, (0, _propTypes.arrayOf)(_propTypes.bool)]),
  margin: spacingPropType,
  marginBottom: spacingPropType,
  marginEnd: spacingPropType,
  marginHorizontal: spacingPropType,
  marginLeft: spacingPropType,
  marginRight: spacingPropType,
  marginStart: spacingPropType,
  marginTop: spacingPropType,
  marginVertical: spacingPropType,
  padding: spacingPropType,
  paddingBottom: spacingPropType,
  padddingEnd: spacingPropType,
  paddingHorizontal: spacingPropType,
  paddingLeft: spacingPropType,
  paddingRight: spacingPropType,
  padddingStart: spacingPropType,
  paddingTop: spacingPropType,
  paddingVertical: spacingPropType,
  width: spacingPropType
};
exports.boxPropTypes = boxPropTypes;